import { render } from "./FischbuchEintragPachtrevier.vue?vue&type=template&id=cd84aee8&scoped=true&ts=true"
import script from "./FischbuchEintragPachtrevier.vue?vue&type=script&lang=ts"
export * from "./FischbuchEintragPachtrevier.vue?vue&type=script&lang=ts"

import "./FischbuchEintragPachtrevier.vue?vue&type=style&index=0&id=cd84aee8&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd84aee8"]])

export default __exports__